module.exports = __webpack_public_path__ + "img/config.ee61aa55.svg";